require("../../src/content/themes/association-wordpress-theme/js/main.js");
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'

import 'bootstrap'

require.context('../images', true)
require.context('../../src/content/themes/association-wordpress-theme/img', true)

